export default "__VITE_ASSET__BNW0kl68__"